import React, { useContext, useEffect} from "react";
import Breadcrumb from "./components/Breadcrumb";
import { useParams } from "react-router-dom";
import Banner from "./components/Banner";
import { BookingComponent } from "../../components";
import HotelContent from "./components/HotelContent";
import useFetch from "../../commons/useFetch";
import { ContextHotel} from "../../contexts/Hotels";

function HotelDetail() {
  const { id } = useParams();
  const {data : hotels}=useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/hotels/'+ id);
  const { onClickId } = useContext(ContextHotel);
  const pathname = `/hotel/${id}`;
  const hotelId = window.location.pathname.split("/").pop();
  useEffect(() => {
    if (pathname){
      onClickId(hotelId)
    }else{
      onClickId(null)
    }
  }, [hotelId])
  return (
    <div id="hotelDetail" className=" detailPage">
      {hotels && <Banner hotels={hotels} />}
      <BookingComponent />
      {hotels && <Breadcrumb hotels={hotels} />}
      {hotels && <HotelContent hotels={hotels}  />}
    </div>
  );
}
export default HotelDetail;
